import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import { ClientesModel } from "./clientes.model";
import { ClientesService } from './clientes.service';
import { Funcoes } from "../funcoes";
import { PaisesService } from "../paises/paises.service";
import { Global } from "../global";
import { TiposClientesService } from "./tipos-clientes.service";
import { UnidadesService } from "../unidades/unidades.service";
import { MoedasService } from "../moedas/moedas.service";
import { BancosService } from "../bancos/bancos.service";
import { LoginService } from "../login/login.service";
import { MercadoInternoMercadoriasService } from "../mercado-interno-mercadorias/mercado-interno-mercadorias.service";

declare let $: any;

@Component({
  selector: 'app-clientes-form',
  templateUrl: './clientes-form.component.html'
})
export class ClientesFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  cliente: ClientesModel = new ClientesModel();
  listPaises = [];
  listTiposClientes = [];
  listUnidades = [];
  listMoedas = [];
  listBancos = [];
  listIdiomas = [];
  mascaraCNPJ = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  tiposSelecionados = [];
  listTodosClientes = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  idCliente = null;
  listMercadoriasMI = [];
  modalTaxaForm: any = { id_mercadoria: null, taxa: '0,00' };
  modalTaxaEditIndex: number = null;
  modalTaxaSubmitted: boolean = false;

  podeFaturar = false;
  enviando = false;

  listFormasPagamento = [{
    "valor": "deposito",
    "texto": "Depósito"
  }/*,{
    "valor": "boleto",
    "texto": "Boleto"
  }*/];

  listTiposFaturamento = [{
    "valor": "individual",
    "texto": "Individual"
  }, {
    "valor": "multiplo",
    "texto": "Multiplo"
  }];

  listTiposFaturamentoMI = [{
    "valor": "taxa_fixa",
    "texto": "Taxa Fixa"
  }, {
    "valor": "peso",
    "texto": "Peso"
  }, {
    "valor": "peso_taxa",
    "texto": "Peso + Taxa Fixa"
  }];

  listPeriodoFaturamento = [{
    "valor": "diario",
    "texto": "Diário"
  }, {
    "valor": "semanal",
    "texto": "Semanal"
  }, {
    "valor": "quinzenal",
    "texto": "Quinzenal"
  }, {
    "valor": "mensal",
    "texto": "Mensal"
  }];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private clientesService: ClientesService,
    private tiposClientesService: TiposClientesService,
    private paisesService: PaisesService,
    private unidadesService: UnidadesService,
    private moedasService: MoedasService,
    private bancosService: BancosService,
    private mercadoInternoMercadoriasService: MercadoInternoMercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private loginService: LoginService
  ) {

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'financeiro') {
          this.podeFaturar = data.privilegios[i].editar;
        }
      }
    });

    this.form = formBuilder.group({
      id_cliente: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(80)
      ]],
      nome_tratamento: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
        //Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
      ]],
      forma_pagamento: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_moeda: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_banco: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      valor_preliminares: ['', [
        Validators.required
      ]],
      valor_laudo_pdf: ['', [
        Validators.required
      ]],
      valor_laudoscd: ['', [
        Validators.required
      ]],
      valor_laudoscd_fixo: ['', [
        Validators.required
      ]],
      valor_laudostecnicos: ['', [
        Validators.required
      ]],
      taxa_laboratorial: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      tipo_faturamento_mi: ['taxa_fixa', [
        Validators.required,
        BasicValidators.notNull
      ]],
      valor_mi_taxa_fixa: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      faturamento_tipo: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      periodo_faturamento: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      prazo_pagamento_boleto: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      prazo_pagamento_deposito: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      cnpj: ['', [
        BasicValidators.cnpj
      ]],
      endereco: [],
      cep: [],
      bairro: [],
      cidade: [],
      estado: [],
      id_pais: [],
      telefone: [],
      responsavel: [],
      celular: [],
      site: [],
      tipos: [],
      com_nota_fiscal: [],
      idioma: ['pt', [
        Validators.required,
        BasicValidators.notNull
      ]]
    });
  }

  addNotificacao(tipo = 'preliminares') {

    this.cliente.notificacoes.push({ 'id_cliente': null, 'email': '', 'tipo': tipo });

    /*
    // add address to the list
    const control = <FormArray>this.form.controls['notificacoes'];
    control.push(this.initNotificacoes());*/
  }

  removeNotificacao(i: number) {
    // remove address from the list
    const control = <FormArray>this.form.controls['notificacoes'];
    control.removeAt(i);
  }

  removeEmail(i) {
    this.cliente.notificacoes.splice(i, 1);
  }

  addEmailFinanceiroPorUnidade(id_unidade) {

    if (!this.cliente.notificacoes_financeiro) {
      this.cliente.notificacoes_financeiro = [];
    }

    this.cliente.notificacoes_financeiro.push({
      "id_cliente": null,
      "email": "",
      "id_unidade": id_unidade
    });
  }

  removeEmailFinanceiroPorUnidade(i) {
    this.cliente.notificacoes_financeiro.splice(i, 1);
  }

  addVisibilidade() {
    if (!this.cliente.visibilidades) {
      this.cliente.visibilidades = [];
    }
    this.cliente.visibilidades.push({
      id_cliente: this.cliente.id_cliente || null,
      id_cliente_visivel: null
    });
  }

  removeVisibilidade(i: number) {
    if (this.cliente.visibilidades) {
      this.cliente.visibilidades.splice(i, 1);
    }
  }

  getOutrosClientesDisponiveis(currentValue: any) {
    if (!this.listTodosClientes) {
      return [];
    }

    const selectedIds = (this.cliente.visibilidades || [])
      .map(v => typeof v === 'object' && v !== null ? v.id_cliente_visivel : v)
      .filter(id => id !== null && id !== undefined && id !== '' && String(id) !== String(currentValue));

    const currentClientId = this.idCliente || (this.cliente ? this.cliente.id_cliente : null);

    return this.listTodosClientes.filter(c => {
      const cId = String(c.id_cliente);
      if (currentClientId && cId === String(currentClientId)) {
        return false;
      }
      if (selectedIds.map(id => String(id)).indexOf(cId) >= 0) {
        return false;
      }
      return true;
    });
  }

  abrirModalTaxaMercadoria(index = null) {
    this.modalTaxaSubmitted = false;
    this.modalTaxaEditIndex = index;
    if (index !== null && this.cliente.taxas_mercadorias && this.cliente.taxas_mercadorias[index]) {
      const item = this.cliente.taxas_mercadorias[index];
      this.modalTaxaForm = {
        id_mercadoria: item.id_mercadoria,
        taxa: item.taxa
      };
    } else {
      this.modalTaxaForm = {
        id_mercadoria: null,
        taxa: '0,00'
      };
    }
    $('#modalTaxaMercadoria').modal('show');
  }

  salvarTaxaMercadoria() {
    this.modalTaxaSubmitted = true;
    if (!this.modalTaxaForm.id_mercadoria) {
      return;
    }
    if (this.modalTaxaForm.taxa === null || this.modalTaxaForm.taxa === '' || this.modalTaxaForm.taxa === undefined) {
      return;
    }

    if (!this.cliente.taxas_mercadorias) {
      this.cliente.taxas_mercadorias = [];
    }

    const mercadoriaObj = this.listMercadoriasMI.find(m => String(m.id) === String(this.modalTaxaForm.id_mercadoria));
    const nomeMercadoria = mercadoriaObj ? (mercadoriaObj.nome_pt || mercadoriaObj.nome_padrao || mercadoriaObj.nome || '') : '';

    if (this.modalTaxaEditIndex !== null) {
      this.cliente.taxas_mercadorias[this.modalTaxaEditIndex] = {
        id_cliente: this.cliente.id_cliente,
        id_mercadoria: this.modalTaxaForm.id_mercadoria,
        taxa: this.modalTaxaForm.taxa,
        mercadoria: mercadoriaObj || { id: this.modalTaxaForm.id_mercadoria, nome_pt: nomeMercadoria }
      };
    } else {
      const exists = this.cliente.taxas_mercadorias.some(t => String(t.id_mercadoria) === String(this.modalTaxaForm.id_mercadoria));
      if (!exists) {
        this.cliente.taxas_mercadorias.push({
          id_cliente: this.cliente.id_cliente,
          id_mercadoria: this.modalTaxaForm.id_mercadoria,
          taxa: this.modalTaxaForm.taxa,
          mercadoria: mercadoriaObj || { id: this.modalTaxaForm.id_mercadoria, nome_pt: nomeMercadoria }
        });
      }
    }

    this.ordenarTaxasMercadorias();
    $('#modalTaxaMercadoria').modal('hide');
  }

  removerTaxaMercadoria(index: number) {
    if (this.cliente.taxas_mercadorias && this.cliente.taxas_mercadorias.length > index) {
      this.cliente.taxas_mercadorias.splice(index, 1);
      this.ordenarTaxasMercadorias();
    }
  }

  ordenarTaxasMercadorias() {
    if (this.cliente.taxas_mercadorias && Array.isArray(this.cliente.taxas_mercadorias)) {
      this.cliente.taxas_mercadorias.sort((a, b) => {
        const mercA = a.mercadoria || {};
        const mercB = b.mercadoria || {};
        const nomeA = (this.getNomeMercadoriaMI(a.id_mercadoria) || mercA.nome_pt || mercA.nome_padrao || mercA.nome || '').toLowerCase();
        const nomeB = (this.getNomeMercadoriaMI(b.id_mercadoria) || mercB.nome_pt || mercB.nome_padrao || mercB.nome || '').toLowerCase();
        return nomeA.localeCompare(nomeB, 'pt', { sensitivity: 'base' });
      });
    }
  }

  getMercadoriasMIDisponiveis(idMercadoriaAtual = null) {
    if (!this.listMercadoriasMI) {
      return [];
    }
    const selecionadas = (this.cliente.taxas_mercadorias || [])
      .map(t => String(t.id_mercadoria))
      .filter(id => id && String(id) !== String(idMercadoriaAtual));

    return this.listMercadoriasMI
      .filter(m => selecionadas.indexOf(String(m.id)) === -1)
      .sort((a, b) => {
        const nomeA = (a.nome_pt || a.nome_padrao || a.nome || '').toLowerCase();
        const nomeB = (b.nome_pt || b.nome_padrao || b.nome || '').toLowerCase();
        return nomeA.localeCompare(nomeB, 'pt', { sensitivity: 'base' });
      });
  }

  getNomeMercadoriaMI(id) {
    if (!this.listMercadoriasMI || !id) {
      return '';
    }
    const found = this.listMercadoriasMI.find(m => String(m.id) === String(id));
    return found ? (found.nome_pt || found.nome_padrao || found.nome || '') : '';
  }

  formatarValor(val: any): string {
    if (val === null || val === undefined || val === '') {
      return '0,00';
    }
    if (typeof val === 'string') {
      val = parseFloat(val.replace(/\./g, '').replace(',', '.'));
    }
    if (isNaN(val)) {
      return '0,00';
    }
    return Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  atualizaValidadoresMI(tipo = this.cliente.tipo_faturamento_mi) {
    if (!this.form || !this.form.controls) {
      return;
    }

    if (this.form.controls['taxa_laboratorial']) {
      this.form.controls['taxa_laboratorial'].setValidators([Validators.required, BasicValidators.notNull]);
      this.form.controls['taxa_laboratorial'].updateValueAndValidity();
    }

    if (this.form.controls['tipo_faturamento_mi']) {
      this.form.controls['tipo_faturamento_mi'].setValidators([Validators.required, BasicValidators.notNull]);
      this.form.controls['tipo_faturamento_mi'].updateValueAndValidity();
    }

    if (tipo === 'taxa_fixa' || tipo === 'peso_taxa') {
      if (this.form.controls['valor_mi_taxa_fixa']) {
        this.form.controls['valor_mi_taxa_fixa'].setValidators([Validators.required, BasicValidators.notNull]);
        this.form.controls['valor_mi_taxa_fixa'].updateValueAndValidity();
      }
    } else {
      if (this.form.controls['valor_mi_taxa_fixa']) {
        this.form.controls['valor_mi_taxa_fixa'].clearValidators();
        this.form.controls['valor_mi_taxa_fixa'].updateValueAndValidity();
      }
    }
  }

  ngOnInit() {

    this.listIdiomas = [{
      "valor": "pt",
      "texto": this.func.traduzir('front.portugues')
    }, {
      "valor": "en",
      "texto": this.func.traduzir('front.ingles')
    }];

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
      this.cliente.notificacoes = [{ 'id_cliente': null, 'email': '', 'tipo': 'preliminares' }];
      this.cliente.tipo_faturamento_mi = 'taxa_fixa';
    }

    this.mercadoInternoMercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadoriasMI = (json.Payload || []).sort((a, b) => {
            const nomeA = (a.nome_pt || a.nome_padrao || a.nome || '').toLowerCase();
            const nomeB = (b.nome_pt || b.nome_padrao || b.nome || '').toLowerCase();
            return nomeA.localeCompare(nomeB, 'pt', { sensitivity: 'base' });
          });
          this.ordenarTaxasMercadorias();
        },
        error => {
          this.func.showErro(error.json());
        });

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento', 'nome'], { 'nome_tratamento': 'a' })
      .subscribe(
        json => {
          this.listTodosClientes = json.Payload || [];
        },
        error => {
          this.func.showErro(error.json());
        });

    let id = this.route.params.subscribe(params => {
      let id = params['id_cliente'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarCliente');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarCliente') : this.func.traduzir('front.cadastrarNovoCliente');
      }

      this.tiposClientesService.get()
        .subscribe(
          json => {
            let tipos = (json.Payload || []).filter(tipo => tipo.id_tipo !== '2' && tipo.id_tipo !== '3' && tipo.id_tipo !== '5' && tipo.id_tipo !== 2 && tipo.id_tipo !== 3 && tipo.id_tipo !== 5);

            let hasTipo8 = tipos.some(t => String(t.id_tipo) === '8');
            if (!hasTipo8) {
              tipos.push({
                id_tipo: '8',
                nome_pt: 'Marítimo / Exames',
                nome_en: 'Maritime / Examinations',
                nome_es: 'Marítimo / Exámenes'
              });
            }

            this.listTiposClientes = tipos;

            if (this.global.debug == true) {
              console.log(json.Payload);
            }
          },
          error => {
            this.listTiposClientes = [
              { id_tipo: '1', nome_pt: 'Importador', nome_en: 'Importer', nome_es: 'Importador' },
              { id_tipo: '4', nome_pt: 'Despachante', nome_en: 'Dispatcher', nome_es: 'Despachante' },
              { id_tipo: '6', nome_pt: 'Agente de Carga', nome_en: 'Freight Forwarder', nome_es: 'Agente de Carga' },
              { id_tipo: '7', nome_pt: 'Mercado Interno', nome_en: 'Internal Market', nome_es: 'Mercado Interno' },
              { id_tipo: '8', nome_pt: 'Marítimo / Exames', nome_en: 'Maritime / Examinations', nome_es: 'Marítimo / Exámenes' }
            ];
            this.func.showErro(error.json());
          });

      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if (this.global.debug == true) {
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.unidadesService.get()
        .subscribe(
          json => {
            this.listUnidades = json.Payload;

            if (this.global.debug == true) {
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.moedasService.get()
        .subscribe(
          json => {
            this.listMoedas = json.Payload;

            if (this.global.debug == true) {
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.bancosService.get()
        .subscribe(
          json => {
            this.listBancos = json.Payload;

            if (this.global.debug == true) {
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (id) {
        this.idCliente = id;

        this.clientesService.getById(id, ['notificacoes', 'notificacoes_financeiro', 'tipos', 'visibilidades', 'taxas_mercadorias'])
          .subscribe(
            json => {
              if (this.pageIsUpd) {
                this.title = this.func.traduzir('front.editarCliente') + ': ' + json.Payload[0].nome;
              } else {
                this.title = this.func.traduzir('front.visualizarCliente') + ': ' + json.Payload[0].nome;
              }

              this.cliente = json.Payload[0];
              if (!this.cliente.tipo_faturamento_mi || this.cliente.tipo_faturamento_mi === 'null') {
                this.cliente.tipo_faturamento_mi = 'taxa_fixa';
              }
              if (this.form && this.form.controls) {
                if (this.form.controls['taxa_laboratorial']) {
                  this.form.controls['taxa_laboratorial'].setValue(this.cliente.taxa_laboratorial, { emitEvent: false });
                }
                if (this.form.controls['tipo_faturamento_mi']) {
                  this.form.controls['tipo_faturamento_mi'].setValue(this.cliente.tipo_faturamento_mi, { emitEvent: false });
                }
                if (this.form.controls['valor_mi_taxa_fixa']) {
                  this.form.controls['valor_mi_taxa_fixa'].setValue(this.cliente.valor_mi_taxa_fixa, { emitEvent: false });
                }
              }
              this.atualizaValidadoresMI(this.cliente.tipo_faturamento_mi);
              if (!this.cliente.idioma || this.cliente.idioma === 'null') {
                this.cliente.idioma = 'pt';
              }

              if (this.cliente.taxas_mercadorias && Array.isArray(this.cliente.taxas_mercadorias)) {
                this.cliente.taxas_mercadorias = this.cliente.taxas_mercadorias.map(t => {
                  return {
                    id_cliente: t.id_cliente || this.cliente.id_cliente,
                    id_mercadoria: t.id_mercadoria,
                    taxa: t.taxa,
                    mercadoria: t.mercadoria || null
                  };
                });
                this.ordenarTaxasMercadorias();
              } else {
                this.cliente.taxas_mercadorias = [];
              }

              if (this.cliente.visibilidades && Array.isArray(this.cliente.visibilidades)) {
                this.cliente.visibilidades = this.cliente.visibilidades.map(v => {
                  if (typeof v === 'object' && v !== null) {
                    return {
                      id_cliente: v.id_cliente || this.cliente.id_cliente,
                      id_cliente_visivel: v.id_cliente_visivel || v.id_cliente_pivot || v.id || v.id_cliente
                    };
                  }
                  return {
                    id_cliente: this.cliente.id_cliente,
                    id_cliente_visivel: v
                  };
                });
              } else {
                this.cliente.visibilidades = [];
              }

              // separa tipos
              for (let x in this.cliente.tipos) {
                let idTipo = '' + this.cliente.tipos[x].id_tipo;
                if (idTipo !== '2' && idTipo !== '3' && idTipo !== '5') {
                  this.tiposSelecionados.push(idTipo);
                  $('#tipo' + idTipo).prop('checked', true);
                }
              }

              if (this.global.debug == true) {
                console.log(json.Payload[0]);
              }
            },
            error => {
              this.func.showErro(error.json());
            });
      }

    });
  }

  changeTipo(option, event) {
    console.log("option", option);
    console.log("event", event);
    console.log("value", event.target.value);
    console.log("checked", event.srcElement.checked);

    if (event.srcElement.checked) {
      this.tiposSelecionados.push(event.target.value);
    } else {
      this.tiposSelecionados = this.tiposSelecionados.filter(item => item !== event.target.value);
    }

    console.log('this.tiposSelecionados', this.tiposSelecionados);
  }

  voltar() {
    this._location.back();
  }

  save() {

    if (!this.form.valid) {
      this.validateForm(this.form);
      return false;
    }

    this.enviando = true;


    this.cliente.tipos = this.tiposSelecionados;

    console.log(this.cliente);
    console.log(JSON.stringify(this.cliente));

    // valida emails para notificações
    let valido = true;

    if (this.cliente.notificacoes) {
      for (let i in this.cliente.notificacoes) {
        if (!this.func.validaEmail(this.cliente.notificacoes[i].email)) {
          valido = false;
        }
      }
    } else {
      valido = false;
    }

    // valida emails para notificações financeiro
    if (this.cliente.notificacoes_financeiro) {
      for (let i in this.cliente.notificacoes_financeiro) {
        if (!this.func.validaEmail(this.cliente.notificacoes_financeiro[i].email)) {
          valido = false;
        }
      }
    }

    if (!valido) {
      this.func.alerta(this.func.traduzir('back.emailInvalido'), this.func.traduzir('front.emailNotificacaoInvalido'), 'erro');
      this.enviando = false;
      return false;
    }

    if (this.cliente.visibilidades) {
      this.cliente.visibilidades = this.cliente.visibilidades
        .filter(v => v && (v.id_cliente_visivel != null && v.id_cliente_visivel !== ''))
        .map(v => {
          return {
            id_cliente_visivel: v.id_cliente_visivel
          };
        });
    }

    let result,
      // values = this.form.value;
      values = this.cliente;

    if (values.id_cliente) {
      result = this.clientesService.editar(values, values.id_cliente);
    } else {
      result = this.clientesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'clientes']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }

  validateForm(form) {
    for (let i in form['controls']) {
      this.form['controls'][i].markAsTouched()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/clientes/clientes-form.component.ts